var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarClock = function SvgCalendarClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "calendarClock_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .5h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#calendarClock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.167 7.167h11.666V5.5H4.167v1.667Zm0 11.666c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V5.5c0-.458.163-.85.49-1.177.326-.327.718-.49 1.177-.49H5V3c0-.236.08-.434.24-.594.16-.16.357-.24.593-.24s.434.08.594.24c.16.16.24.358.24.594v.833h6.666V3c0-.236.08-.434.24-.594.16-.16.358-.24.594-.24s.434.08.593.24c.16.16.24.358.24.594v.833h.833c.459 0 .851.163 1.177.49.327.326.49.718.49 1.177v4.729a5.766 5.766 0 0 0-1.667-.5v-.896H4.167v8.333h5.25c.097.306.211.598.343.875.132.278.289.542.47.792H4.166ZM15 19.667c-1.153 0-2.135-.407-2.948-1.22-.812-.812-1.219-1.794-1.219-2.947s.407-2.136 1.22-2.948c.812-.813 1.794-1.219 2.947-1.219s2.135.406 2.948 1.219c.812.812 1.219 1.795 1.219 2.948s-.407 2.135-1.22 2.948c-.812.812-1.794 1.218-2.947 1.218Zm.417-4.334v-1.917a.4.4 0 0 0-.125-.291.4.4 0 0 0-.584 0 .4.4 0 0 0-.125.291v1.896a.834.834 0 0 0 .25.604l1.271 1.271a.4.4 0 0 0 .292.125.4.4 0 0 0 .291-.125.4.4 0 0 0 0-.583l-1.27-1.27Z",
    fill: "currentColor"
  }))));
};
export default SvgCalendarClock;